<template>
	<!--实物订单详情-->
  <div id="goodsorderInfo">
  	<mt-header title="订单详情"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
		  <a href="/" slot="right">
		    <mt-button><img src="../../../static/images/go_home_ico.png" width="23"/></mt-button>
		  </a>
 	</mt-header>
 	<div class="mt40"> 
 	   <section class="orderType">
 	   	 <p class="colorff8900 font-size10">{{state==1?'待付款':state==2?'交易中':state==3?'待发货':state==4?'待收货':state==5?'交易成功':'交易关闭'}}</p>
 	   	 <P class="color666 font-size8" v-show="state==1">剩余付款时间: {{remainTime}}</P>
 	   	 <P class="color666 font-size8" v-show="state==2">付款成功，正在为您出服务，请稍等</P>
 	   	 <P class="color666 font-size8" v-show="state==3">付款成功，等待为您发货</P>
 	   	 <P class="color666 font-size8 flex-between" v-show="state==4">
 	   	 	<div>
 	   	 	    <p class="font-size9">已发货，您购买的商品正在路上</p>
 	   	 	    <p class="font-size8">还剩{{remainDay}}自动确认收货</p>
 	   	 	</div>
 	   	 	<div>
 	   	 			<span><button @click="tolookLogistics" class="logisticsLook">查看物流 ></button></span>
 	   	 	</div>
 	   	 </P>
 	   	 <P class="color666 font-size8 flex-between" v-show="state==5"><span>感谢您在本商场购物，欢迎您再次光临！</span><span><button @click="tolookLogistics" class="logisticsLook">物流记录</button></span></P>
 	   	 <P class="color666 font-size8" v-show="state==6">您的订单已关闭</P>
 	   </section>
 	   <p class="colorBox"></p>
 	   
 	   <!--收货人-->
 	   <!--<section class="orderType">
 	   	 <div class="goodsaddresswrap">
 	   	 	    <div class="iconaddress">
 	   	 	    	<img src="../../../static/images/address_ico.png"/>
 	   	 	    </div>
 	    			<div class="addresswrap ">
 	    				<p class="mAp1 clearfix font-size10"><span class="float-left">收货人：<i>陈文</i></span> <span class="float-right">155555585555</span></p>
 	    				
 	    				<p class="mAp2"><span class="mAp2-span1 font-size5">收货地址：</span><span class="mAp2-span2">广东省深圳市福田区深南中路 </span><span class="mAp2-span3">新城大厦1楼101深南中路新城大厦1楼101</span></p>
 	    			</div>
 	    	</div>
 	   </section>-->
 	   <section>
 	   	    <div class="goodsaddresswrap">
	   	 	    <span class="iconaddress">
	   	 	    	<img src="../../../static/images/address_ico.png"/>
	   	 	    </span>
				<div class=" peopleleft">
					<p class="mAp1 clearfix font-size10 mb5"><span class="float-left">收货人：<i>{{peopleName}}</i></span> <span class="float-right">{{peoplePhone}}</span></p>
					<p class="mAp2 font-size8"><span class="mAp2-span1">收货地址：</span><span class="mAp2-span2">{{peopleAddress}}</span></p>
				</div>
				<!--<div class=" peopleleft" >
					<p class="mAp1 clearfix font-size10 mb5"><span class="float-left">收货人：<i class="goodsPeople">{{peopleName}}</i></span> <span class="float-right">{{peoplePhone}}</span></p>
					<p class="mAp2 font-size8"><span class="mAp2-span1">收货地址：</span><span class="mAp2-span2">{{peopleAddress}}</span></p>
				</div>-->
				<!--<span class=" peopleright">
					<i class="iconfont icon-youjiantou"></i>
				</span>-->
    	    </div>
 	   </section>
 	   
 	   <p class="colorBox"></p>
 	   <section>
 	   	<div class="reset-mintbox">
			 	<label class="labelr">商品</label>
			 	<!--<input type="text" disabled  :value="goods"/>-->
			 	<label class="labelp">{{goods}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">规格</label>
			 	<!--<input type="text" disabled :value="facevalue"/>-->
			 	<label class="labelp">{{facevalue}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">数量</label>
			 	<!--<input type="text" disabled :value="num" class="colorff5513"/>-->
			 	<label class="labelp colorff5513">{{num}}</label>
		  </div>
 	   </section>
 	   <p class="colorBox"></p>
 	   <section class="orderinfors">
 	   	<div class="reset-mintbox">
			 	<label class="labelr">商品总价</label>
			 	<!--<input type="text" disabled v-model="price" />-->
			 	<label class="labelp">{{price}}{{paytype==1?'元':paytype==2?'元':paytype==3?'元':paytype==4?'V':paytype==5?'元':'V'}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">运费</label>
			 	<!--<input type="text" disabled v-model="freight" />-->
			 	<label class="labelp">{{freight}}{{paytype==1?'元':paytype==2?'元':paytype==3?'元':paytype==4?'V':paytype==5?'元':'V'}}</label>
		  </div>
		  <div class="reset-mintbox" v-show="coupon.length!=0">
			 	<label class="labelr">优惠券</label>
			 	<!--<input type="text" disabled v-model="totalPrice" class="colorff5513"/>-->
			 	<label class="labelp">{{"-"+couponPrice+"元"}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">订单总价</label>
			 	<!--<input type="text" disabled v-model="totalPrice" class="colorff5513"/>-->
			 	<label class="labelp colorff5513">{{totalPrice}}{{paytype==1?'元':paytype==2?'元':paytype==3?'元':paytype==4?'V':paytype==5?'元':'V'}}</label>
		  </div>
		  <div class="reset-mintbox">
			 	<label class="labelr">订单编号</label>
			 	<!--<input type="text" disabled v-model='ordernum'/>-->
			 	<label class="labelp">{{ordernum}}</label>
		  </div>
		  <div class="reset-mintbox" >
			 	<label class="labelr">下单时间</label>
			 	<!--<input type="text" disabled v-model='ordertime'/>-->
			 	<label class="labelp">{{ordertime}}</label>
		  </div>
		  <div class="reset-mintbox" >
			 	<label class="labelr">支付方式</label>
			 	<!--<input type="text" disabled v-model='paytypeText'/>-->
			 	<label class="labelp">{{paytype==1?'微信支付':paytype==2?'支付宝支付':paytype==3?'QQ钱包支付':paytype==4?'V币支付':paytype==5?'话费支付':'电话钱包支付'}}</label>
		  </div>
		  <div class="reset-mintbox" v-show="state==2||state==3||state==4||state==5">
			 	<label class="labelr">支付完成时间</label>
			 	<!--<input type="text" disabled v-model="finishtime"/>-->
			 	<label class="labelp">{{finishtime}}</label>
		  </div>
 	   </section>
 	   <p class="colorBox"></p>
 
 	   <section>
 	   	<p class="precent92 clearfix">
 	   	 <!--待付款-->
 	   	  <span v-show="state==1">
 	   	     <a href="javascript:void(0)" class="btnpay btncancel w50  float-left" @click="btnCancel">取消订单</a>
 	   		 <a href="javascript:void(0)" class="btnpay w50 float-right"  @click="impay">立即付款</a>
 	   	  </span>
 	   	 <!--交易中  交易关闭-->
 	   	    <a href="tel:0755-82126233" class="btnpay" v-show="state==2||state==3||state==4||state==6">联系客服</a>
 	   	 <!--交易成功-->
 	   	    <span v-show="state==5">
 	   	    	<input type="button" value="再次下单" class="btnpay w50 float-left" @click="reorder"/>
 	   	    	 <a href="tel:0755-82126233" class="btnpay w50 float-right">联系客服</a>
 	   	    </span>
 	   	</p>
 	   </section>
 	</div>
  </div>
</template>
 
<script>
 import { MessageBox } from 'mint-ui';
 import { Toast } from 'mint-ui'
 import { Indicator } from 'mint-ui'
 export default{
  	data(){
		return{
			orderId:localStorage.getItem("orderId"),//获取订单id
			state:"", //订单状态
			goods:"",  //分类名称
			type:"",  //商品类型
			price:"",  //商品总价
			ordernum:"", //订单号
			paytype:"", //支付方式
			paytypeText:"", //支付方式文字
			facevalue:"",  //规格
			num:'',//数量
			remainTime:"",//剩余付款时间
			remainDay:"",//剩余自动确认收货时间
			finishtime:"",//支付完成时间
			deliveryTime:"",//发货时间
			coupon:"",//优惠券信息
			couponPrice:"",//优惠券金额
			freight:"",//运费
			totalPrice:"",//订单总价
			//confirmtime:"",//待收货开始时间
			ordertime:"",//下单时间
			urlPrefix:this.URL_PREFIX,
			spsuc:this.URL_PAY,//支付成功后返回页面
			peopleName:'',//姓名
		    peoplePhone:'',//电话
		    peopleAddress:'',//地址
		    callbackUrl:'http://m.vcard8.com/*/Order/goodsorderInfo',  //返回地址
		    md5sign:this.Act_md5sign,
		}
	},
    created:function(){
	  	this.queryInfo();
	},
	methods: {
		//返回按钮
		returnBack(){
	        //this.$router.push({path: "/Order/orderList"});
	        //this.$router.go(-1);
	         this.$router.push({path: "/Order/orderList",query:{state:localStorage.getItem("listState")}});//返回相应订单状态
	    },
	    //查看物流
	    tolookLogistics(){
	    	//this.$router.push({path: "/UserCenter/lookLogistics",query: {orderId:this.orderId}});
	    	this.$http.post(this.URL_PREFIX+"/order/findLogisticsByOrderId.net",{orderid:this.orderId,callbackUrl:this.callbackUrl})
		    .then((res) =>{
//		    	console.log('查询物流地址');
//		    	console.log(res);
		    	location.href=res.data;
		    });
	    },
	    //待付款状态中的立即付款
		impay(){
		  	this.$http.post(this.URL_PREFIX+"/order/createOrder.net",{orderId:this.orderId,spsuc:this.spsuc})
		    .then((res) =>{
//		      console.log('立即支付');
//		      console.log(res);
		  	  if(res.data.code!=200){
		  	  	  Toast(res.data.msg);
		  	  }else{
		  	  	  var orderId=res.data.remarks;
		  	  	  localStorage.setItem("orderId",orderId);
		  	  	  location.href=res.data.obj;
		  	  }
		   });
		},
	    //获取订单信息
	    queryInfo(){
	  	this.$http.post(this.URL_PREFIX+"/order/findOrderByOid.net",{orderId:this.orderId})
	  	  .then((res) =>{
//	  	  	 console.log('实物订单状态');
//	  	  	 console.log(res);
	  	  	 this.state=res.data.obj.state; //订单状态
	  	  	 this.goods=res.data.obj.tranEvent; //分类名称
	  	  	 this.facevalue=res.data.obj.pName; //规格
	  	  	 this.type=res.data.obj.tranType; //商品类型
	  	  	 this.num=res.data.obj.num; //商品数量
	  	  	 this.ordernum=res.data.obj.orderId; //订单号
	  	  	 this.ordertime=res.data.obj.cTime; //下单时间
	  	  	 this.deliveryTime=res.data.obj.deliveryTime; //发货时间
	  	  	 this.paytype=res.data.obj.payType;//支付方式
	  	  	 this.freight=res.data.obj.freight;//运费
	  	  	 let price1=res.data.obj.amount;  //订单金额	 
	  	  	 let addressId=res.data.obj.addressId;//收货地址ID
	  	  	 this.selectAction(addressId);
	  	  	 this.coupon=res.data.obj.coupon;//优惠信息
	  	  	 if(this.coupon.length==0){
	  	  	 	this.price=(parseFloat(res.data.obj.amount)-parseFloat(this.freight)).toFixed(2);
	  	  	 }else{
	  	  	 	this.price= this.coupon.ydetails;
	  	  	 	this.couponPrice=res.data.obj.coupon.yamount;//优惠金额
	  	  	 }
	  	  	 this.totalPrice=price1;//商品金额
	  	  	 this.finishtime=res.data.obj.fTime; //支付完成时间
	  	  	 if(this.state==1){
	  	  	 	 this.countDown();
	  	  	 }else if(this.state==4){
	  	  	 	 //this.confirmtime=new Date();//待收货开始时间
	  	  	 	 this.countDownhour();
	  	  	 }
	  	  });
	    },
	    //请求收货人地址
    	selectAction(selectId){
          this.$http.post(this.URL_PREFIX+"/user/findAddressById.net",{id:selectId})
		  	  .then((res) =>{
		  	   this.peopleName=res.data.obj.name;               //用户名
		  	   this.peoplePhone=res.data.obj.phone;          //电话号码     
		  	   this.peopleAddress=res.data.obj.address;        //收货地址
		  });
    	},
	    //实物再次下单
	  	reorder(){
	  	Indicator.open();
	    this.$http.post(this.URL_PREFIX+"/order/findOrderByProduct.net",{orderId:this.orderId})
		    .then((res) =>{
		    	Indicator.close();
		    	var pid=res.data.obj.proId;
		    	var num=res.data.obj.num;
		    	var orderaddressId=res.data.obj.addressId;//再次下单地址ID 
		     	localStorage.setItem("proName",res.data.obj.pName);//实物类型
		     	localStorage.setItem("tName",res.data.obj.tranEvent);//商品类型
		     	localStorage.setItem("ttype",res.data.obj.tranType); //商品类型
		     	localStorage.setItem("pic",res.data.obj.cateIcon);//图标
		     	localStorage.setItem("orderIdflag",res.data.obj.orderId);//订单列表返回标志
		     	localStorage.setItem("num",num);//数量
		     	localStorage.setItem("pid",pid);//商品ID
		     	var obj=JSON.stringify(res.data.obj.pays);
		     	localStorage.setItem("payType",obj);		     	
		     	localStorage.setItem("totalPrice",res.data.obj.amount);//总金额
		     	var obj=JSON.stringify(res.data.obj.pays);
		     	localStorage.setItem("payType",obj);		
		        localStorage.setItem("freightR",res.data.obj.freight.R);  //保存人民币的运费
 	            localStorage.setItem("freightV",res.data.obj.freight.V);  //保存V币的运费
		     	localStorage.setItem("totalPriceOb",(res.data.obj.amount-res.data.obj.freight.R).toFixed(2));//总金额-运费
//		     	this.validateStock(pid,num);//实物库存监控
                this.$router.push({path: '/Order/index',query:{selectId:orderaddressId}});
		    });
	 	},
	 	 //实物库存风控验证
//	    validateStock(pid,num){
//	  	Indicator.open();
//	 	  this.$http.post(this.URL_PREFIX+"/order/exisStock.net",{proId:pid,num:num})
//		  	.then((res) =>{
//		  	  	 Indicator.close();
//		  	  	 if(res.data.code==200){
//		  	  	 	this.$router.push({path: '/Order/index'});
//		  	  	 }else{
//		  	  	 	Toast(res.data.msg);
//		  	  	 }
//		    });
//	    },
	    //剩余付款时间计时函数
	    countDown(){
	      var countDownTimer;	     
	  	  var nowDate = new Date();//当前时间
		  var orderTime= this.ordertime;//下单开始时间   
		  orderTime=orderTime.replace(new RegExp(/-/gm) ,"/"); 
//		  console.log(orderTime);
		  var addTime=new Date(orderTime);
		  var auto_order_cancel=2;
		  var auto_totals=parseInt(auto_order_cancel*60*60);
		  var ad_totals= parseInt((addTime.getTime()/1000)+auto_totals);  ///下单总秒数
          var totals= parseInt(ad_totals-(nowDate.getTime()/ 1000));///支付时长
	      if(totals>0){
	        var hour   = parseInt((totals / 3600) % 24);
	        var minute = parseInt((totals / 60) % 60);
	        var second = parseInt(totals % 60);
	        this.remainTime=hour+'时'+minute+'分'+second+'秒';
	        countDownTimer=setTimeout(() => {	        	 
	        this.countDown(); 
	        }, 1000);
		    }else{
		      this.$http.post(this.URL_PREFIX+"/order/payError.net",{orderId:this.orderId})
		  	  .then((res) =>{
		  	  	 if(res.data.code==200){
		  	  	   this.state=6;
		  	  	   clearTimeout(countDownTimer);
		  	  	 }else{
		  	  	 }
		  	  });
		    }        
	    },
	    //剩余自动确认收货时间
	    countDownhour(){
	      var countDownDay;
	  	  var nowDate = new Date();//当前时间
		  var deliveryTime= this.deliveryTime;//发货时间  
		  deliveryTime=deliveryTime.replace(new RegExp(/-/gm) ,"/"); 
		  var addTime=new Date(deliveryTime);
		  var auto_order_cancel=15*24;//15天-15*24
		  var auto_totals=parseInt(auto_order_cancel*60*60);
		  var ad_totals= parseInt((addTime.getTime()/1000)+auto_totals);  ///下单总秒数
          var totals= parseInt(ad_totals-(nowDate.getTime()/ 1000));//收货总时长
          if(totals>0){
	      	var day    = parseInt(totals/86400);
	        var hour   = parseInt((totals / 3600) % 24);
	        this.remainDay=day+'天'+hour+'时';
	        countDownDay=setTimeout(() => {
	        this.countDownhour(); 
	        }, 1000);
	        }else{		    	
		  	  this.$http.post(this.URL_PREFIX+"/order/confirmReceipt.net",{orderId:this.orderId})
			    .then((res) =>{
			    	if(res.data.code==200){
			  	  	  this.state=5;
			  	  	  clearTimeout(countDownDay);
			  	    }
			    });
		    }
	    },
	    //取消订单
		  btnCancel(){
		  	MessageBox.confirm('',{message:'您确认取消该订单吗?', title:'提示'}).then(action => {
	        var sign=md5('orderId='+this.orderId+'&'+this.md5sign);
	        this.$http.post(this.URL_PREFIX+"/activity/clearOrderById",{orderId:this.orderId,sign:sign})
		  	  .then((res) =>{
		  	  	   if(res.data.code!=200){
		  	  	   	  Toast(res.data.msg);
		  	  	   }else{
		  	  	   	  this.state=6;
		  	  	   	  Toast("已取消");
		  	  	   }
		  	  });
		       
		     },
		     action=>{
		
		     },
			  );
		  }
	}
  }
</script>

<style scoped="scoped">
#areaText{position: absolute;top: 0;z-index:-1;border: none;opacity: 0;}
.orderType{padding:10px;background: #fff;}
.orderType p{line-height: 25px;}
.orderinfors{padding: 5px 0 8px 0;background: #fff;}
.precent92{width: 92%;margin: 10px auto;}
.btnpay.w50{width: 48%;}
.secretinfobox{background: #fff;overflow: hidden;position: relative;}
.secretinfo_title{padding: 12px;overflow: hidden;border-bottom:1px solid #D6D6D6;}
.border-bottom-lined6{border-bottom:1px solid #D6D6D6;padding: 5px 0 8px 0;}
.btnpay{width: 100%;height: 40px;background: #ff8920;color: #fff;font-size: 1.0rem;border-radius: 5px;-webkit-border-radius: 5px;margin-top:15px;border: none;line-height: 40px;display: inline-block;text-align: center;}
.btncancel{background: #fff;color: #666;border: 1px solid #ddd;height: 39px;}
.reset-mintbox{height: 48px;line-height: 48px;padding: 0 15px 0 15px;background: #fff;border-bottom: 1px solid #eee;}
.reset-mintbox .labelr{float: left;color: #666;font-size: 0.8rem;}
/*.reset-mintbox input{text-align: right;float: right;color: #333;font-size: 0.9rem;border: none;margin-top: 14px;}*/
.reset-mintbox .labelp{text-align: right;float: right;color: #333;font-size: 0.9rem;border: none;}
.reset-mintbox .colorff5513{color:#ff5513;}
.orderinfors div.reset-mintbox,.secretinfobox div.reset-mintbox{border-bottom: none;height: 30px;line-height: 30px;}
.orderinfors div.reset-mintbox input,.secretinfobox div.reset-mintbox input{margin-top: 3px;}
.flex-between{display: flex;justify-content: space-between;}

/*收货人*/
/*.iconaddress{float: left;width: 25px;margin-top: 14px;}
.addresswrap{float: left;width: 86%;margin-left: 6px;}
.goodsaddresswrap{overflow: hidden;}
.iconaddress img{width: 100%;}*/

/*收货人弹性盒*/
.goodsaddresswrap{display: flex;padding:15px 10px;align-items: center;}
.iconaddress{width: 30px;}
.iconaddress img{width: 100%;}
.peopleleft{margin-left: 5px;margin-right: 3px;color:#666;}
.logisticsLook{color: #ff8920;font-size:0.8rem;border: 0;background: transparent;}
</style>


// WEBPACK FOOTER //
// src/views/Order/goodsorderInfo.vue